export enum SlideState {
  Open = 'open',
  Closed = 'closed'
}